import { flatten, values } from 'ramda';
import type { KenmerkLookup } from '../../types';

/**
 * Flattens kenmerkLookup into a single array of kenmerken
 */
const flattenKenmerkLookup = (
  kenmerkLookup: KenmerkLookup | null,
): Array<{ id: number; tag: string | null; checked: boolean }> => {
  if (!kenmerkLookup) return [];
  return flatten(values(kenmerkLookup));
};

export default flattenKenmerkLookup;
